import { useEffect } from "react";

const useWidthChange = (ref, onChange) => {
    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            onChange(width);
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref, onChange]);
};

export default useWidthChange;